<template lang="pug">
    div.contact
        v-menu(v-model='openEditDialog' :nudge-width='400' absolute :close-on-content-click="false")
            template(v-slot:activator='{ on, attrs }')
                div(v-bind='attrs' v-on='on')
                    v-row.ma-auto.justify-center
                        v-col.text-center(cols="3")
                            v-btn(
                                class="mx-2"
                                fab
                                large
                                color="white"
                            )
                                v-icon() mdi-phone
                        v-col.text-center(cols="8")
                            v-btn(
                                x-large
                                color="success"
                                dark
                                width="100%"
                                height="100%" 
                            )
                                v-icon.mx-2() mdi-whatsapp
                                h4 +6 {{contact.phone}}
            v-card
                v-card-title.font-weight-bold.mt-n1 Update Contact
                v-card-text.my-n2
                    v-row.px-3
                        v-text-field(v-model="newPhone" outlined label="Phone Number")
                v-card-actions
                    v-spacer
                    v-btn.mb-2(small text @click.native="openEditDialog = false; newPhone = contact.phone;") Cancel
                    v-btn.mb-2.mr-2(small depressed dark color="accent" @click="changeText()") Update

                    
</template>
<script>
export default {
    props:['contact'],
    data: () => ({
        openEditDialog: false,
        newPhone: '',
    }),
    mounted () {
        this.newPhone = this.contact.phone
    },
    methods: {
        changeText () {
        this.contact.phone = this.newPhone,
        this.openEditDialog = false
        }
    }
}
</script>
<style scoped>
    .contact{
        width: 100%;
    }
</style>